'use client';
import { useEffect, useState } from 'react';

interface PaginationProps {
  currentPage: number;
  totalPages: number;
}

export function Pagination(props: PaginationProps) {
  const [pathName, setPathName] = useState('');
  const [search, setSearch] = useState('');
  useEffect(() => {
    setPathName(window.location.pathname);
    const params = new URLSearchParams(window.location.search);
    params.delete('page');
    setSearch(params.toString());
  }, []);

  const prevPage3 = props.currentPage - 3;
  const prevPage2 = props.currentPage - 2;
  const prevPage1 = props.currentPage - 1;
  const nextPage1 = props.currentPage + 1;
  const nextPage2 = props.currentPage + 2;
  const nextPage3 = props.currentPage + 3;

  return (
    <div className="text-center">
      <ul className="c-pagination">
        {props.currentPage > 1 && (
          <li className="c-pagination__prev">
            <a
              rel="nofollow"
              href={`${pathName}${search ? search + '&' : '?'}page=${
                props.currentPage - 1
              }`}
            >
              前へ
            </a>
          </li>
        )}
        {prevPage3 > 0 && (
          <li className="c-pagination__page ">
            <a
              rel="nofollow"
              href={`${pathName}${
                search ? search + '&' : '?'
              }page=${prevPage3}`}
            >
              {prevPage3}
            </a>
          </li>
        )}
        {prevPage2 > 0 && (
          <li className="c-pagination__page ">
            <a
              rel="nofollow"
              href={`${pathName}${
                search ? search + '&' : '?'
              }page=${prevPage2}`}
            >
              {prevPage2}
            </a>
          </li>
        )}
        {prevPage1 > 0 && (
          <li className="c-pagination__page ">
            <a
              rel="nofollow"
              href={`${pathName}${
                search ? search + '&' : '?'
              }page=${prevPage1}`}
            >
              {prevPage1}
            </a>
          </li>
        )}
        {props.currentPage > 0 && (
          <li className="c-pagination__page active">
            <a href="#">{props.currentPage}</a>
          </li>
        )}
        {nextPage1 <= props.totalPages && (
          <li className="c-pagination__page ">
            <a
              rel="nofollow"
              href={`${pathName}${
                search ? search + '&' : '?'
              }page=${nextPage1}`}
            >
              {nextPage1}
            </a>
          </li>
        )}
        {nextPage2 <= props.totalPages && (
          <li className="c-pagination__page ">
            <a
              rel="nofollow"
              href={`${pathName}${
                search ? search + '&' : '?'
              }page=${nextPage2}`}
            >
              {nextPage2}
            </a>
          </li>
        )}
        {nextPage3 <= props.totalPages && (
          <li className="c-pagination__page ">
            <a
              rel="nofollow"
              href={`${pathName}${
                search ? search + '&' : '?'
              }page=${nextPage3}`}
            >
              {nextPage3}
            </a>
          </li>
        )}
        {props.currentPage < props.totalPages && (
          <li className="c-pagination__next">
            <a
              rel="nofollow"
              href={`${pathName}${search ? search + '&' : '?'}page=${
                props.currentPage + 1
              }`}
            >
              次へ
            </a>
          </li>
        )}
      </ul>
    </div>
  );
}
